<ng-container
    *ngIf="{
        user: selectedCustomerUser$ | async,
        isMagayaNetwork: isMagayaNetwork$ | async,
        saving: saving$ | async,
        error: error$ | async
    } as vm"
>
    <div class="bg-white min-vh-100">
        <div class="container-fluid py-3 pb-5">
            <div class="row justify-content-center">
                <div class="col-12 col-lg-9 col-xxxl-6">
                    <div class="small text-muted mb-3 border-bottom pb-2">
                        <a class="text-muted" [routerLink]="['/']">Qwyk</a>
                        &rsaquo;

                        <a class="text-muted" [routerLink]="['/administration']">
                            {{ 'hub.administration.title' | translate }}
                        </a>
                        &rsaquo;

                        <a class="text-muted" [routerLink]="['./../']">
                            {{ 'hub.administration.portal-users.title' | translate }}
                        </a>
                        &rsaquo;

                        <a class="text-muted font-weight-bold" [routerLink]="['./']">
                            {{
                                vm.user
                                    ? vm.user.name
                                    : ('common.new' | translate)
                            }}
                        </a>
                    </div>

                    <div
                        *ngIf="vm.user"
                        class="border-bottom d-flex mb-3 pb-3 align-items-center"
                    >
                        <div class="flex-grow-1">
                            <span
                                *ngIf="!vm.user.email_verified"
                                class="badge badge-outline-warning mr-2"
                                style="font-size: 100%;"
                                [pTooltip]="'hub.administration.portal-users.email-verification-is-pending' | translate"
                            >
                                <fa-icon [icon]="['fas', 'envelope']"></fa-icon>
                                {{ 'hub.administration.portal-users.email-pending' | translate }}
                            </span>

                            <span
                                *ngIf="vm.user.email_verified && !vm.user.approved"
                                class="badge badge-outline-danger mr-2"
                                style="font-size: 100%;"
                                [pTooltip]="'hub.administration.portal-users.this-user-needs-to-be-approved-before-they-can-access-your-portal' | translate"
                            >
                                <fa-icon [icon]="['fas', 'shield-check']"></fa-icon>
                                {{ 'hub.administration.portal-users.approval-pending' | translate }}
                            </span>

                            <span *ngIf="vm.user.approved" class="text-muted">
                                <fa-icon
                                    [icon]="['fas', 'shield-check']"
                                    class="text-success mr-1"
                                ></fa-icon>
                                {{ 'portal.invoices.index-page.index.search.invoice-index-approval-status-options.approved' | translate }}
                                {{ vm.user.approved_at | amTimeAgo }}
                                {{ 'common.by' | translate }}
                                {{ vm.user.approved_by }}
                            </span>
                        </div>
                    </div>

                    <div class="d-flex flex-row justify-content-between mb-3">
                        <h3 class="font-weight-normal m-0">
                            {{ 'hub.administration.portal-users.portal-user' | translate }}
                        </h3>
                    </div>

                    <qwyk-customer-user-detail
                        *ngIf="vm.user; else createCustomerUserTemplate"
                        #customerUserComponent
                        [user]="vm.user"
                        [error]="vm.error"
                        [isMagayaNetwork]="vm.isMagayaNetwork"
                        [saving]="vm.saving"
                        (save)="onUpdate($event)"
                        (deactivate)="onDeactivate($event)"
                        (activate)="onActivate($event)"
                    ></qwyk-customer-user-detail>

                    <ng-template #createCustomerUserTemplate>
                        <qwyk-customer-user-create
                            [saving]="vm.saving"
                            [error]="vm.error"
                            (save)="onCreate($event)"
                        ></qwyk-customer-user-create>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</ng-container>
